// 倒计时
//生成随机的小时数，作为倒计时的时长
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

//计算并返回倒计时的时，分，秒
function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
//设置一个新的倒计时结束时间
function setupNewCountdown() {
    
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  //将结束时间保存到全局变量endTimeG
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

//启动倒计时功能，每秒更新页面显示
function getCutDownTime() {
    //初始化倒计时
  setupNewCountdown();
  //清除已有的定时器（避免多个定时器同时运行）
  if (intervalId) clearInterval(intervalId);
  //启动新的定时器，每1s执行一次
  intervalId = setInterval(function () {
    //计算剩余时间
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

//整个页面的主入口函数，负责初始化和启动所有功能
//页面缩放适配，图片懒加载，图片预加载，swiper轮播图初始化，各种事件绑定
function mainRender() {
  $(function () { //dom加载完成后执行
    $("#root").css("zoom", "normal");
    //1，计算缩放比例并应用
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    //2,监听窗口大小变化
    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
      config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  };

  //根据用户选择的产品规格，动态切换显示对应的图片
  let imgArr = [
    'https://cdn.shopify.com/s/files/1/0816/5412/0738/files/20250614-p2.png',
    'https://cdn.shopify.com/s/files/1/0816/5412/0738/files/20250614-p4.png',
    'https://cdn.shopify.com/s/files/1/0816/5412/0738/files/20250614-p6.png',
    'https://cdn.shopify.com/s/files/1/0816/5412/0738/files/20250614-p8.png',

    'https://cdn.shopify.com/s/files/1/0816/5412/0738/files/20250614-p1.png',
    'https://cdn.shopify.com/s/files/1/0816/5412/0738/files/20250614-p3.png',
    'https://cdn.shopify.com/s/files/1/0816/5412/0738/files/20250614-p5.png',
    'https://cdn.shopify.com/s/files/1/0816/5412/0738/files/20250614-p7.png',

   'https://cdn.shopify.com/s/files/1/0903/9233/0531/files/1_f69dac93-5e9b-423b-85b4-afa0928b400f.png?v=1784024394',
    'https://cdn.shopify.com/s/files/1/0903/9233/0531/files/2_0b0ca313-5d3e-4458-ae03-b7e29048910f.png?v=1784024394',
    'https://cdn.shopify.com/s/files/1/0903/9233/0531/files/3_4c656aba-14da-4310-af33-05d24a1ab24f.png?v=1784024395',
    'https://cdn.shopify.com/s/files/1/0903/9233/0531/files/4_6c88d49c-ebfe-43af-80e3-96235a293820.png?v=1784024394',

    'https://cdn.shopify.com/s/files/1/0903/9233/0531/files/5_23d42854-74f7-4396-8e36-7349a7003665.png?v=1784024394',
    'https://cdn.shopify.com/s/files/1/0903/9233/0531/files/6_85699f96-6c2b-4049-ab7d-41468462eb9c.png?v=1784024394',
    'https://cdn.shopify.com/s/files/1/0903/9233/0531/files/7_f0aad48f-5365-4dc6-8edb-c6f552c5fa08.png?v=1784024394',
    'https://cdn.shopify.com/s/files/1/0903/9233/0531/files/8_6080204a-8723-4ec2-8945-0be2be876cb3.png?v=1784024394',
  ]

  preloadImages(imgArr)

  new Swiper(".sp-swiper1", {
    speed: 9000,
    autoplay: true,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: "auto",
    spaceBetween: 0,
    loop: true,
  });

  new Swiper("#sp-swiper2", {
    autoplay: {
      disableOnInteraction: false,
      delay: 2500,
    },
    spaceBetween: 0,
    slidesPerView: "auto",
    centeredSlides: true,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });

  let prods = window.product


  function getCur(that){

  
    //1，找到产品所在的容器
    //2,获取选中的颜色，尺寸，类型
    //3,从产品数组中筛选匹配的产品
    //返回完整的产品信息对象
    let product_con = $(that).closest('.product-part');
    
    // let style = product_con.find('#sp-style div.active').attr('data-val')
    let color = product_con.find('#sp-color div.active').attr('data-val')
    let size = product_con.find('#sp-size div.active').attr('data-val')
    let type = product_con.find('#sp-type div.active').attr('data-val')
    return prods.filter(item=> item.option1  == color && item.option2 == size && item.option3 == type)[0]
  }
  //根据数量和规格更新页面价格
  function changePrice(that){
    //获取当前选中的产品信息
    let product_con = $(that).closest('.product-part');
    let num = product_con.find('#calcNumber').val()
    
    let that1 = that
    //计算价格
    let price = (getCur(that1).price * num / 100).toFixed(2)
    let compare = (getCur(that1).compare_at_price * num / 100).toFixed(2)
    // price = (price + '').replace('.', ',')
    // compare = (compare + '').replace('.', ',')
    //更新页面价格显示
    product_con.find('#sp_price1').html(price)
    product_con.find('#sp_price2').html(compare)
    let off_font = 100 - Math.ceil(getCur(that1).price / getCur(that1).compare_at_price * 100)
    product_con.find(".price-group .sp-row span").html(off_font);
  }

  //UI交互函数

  //选项切换相关
  $(".sp-option").click(function () {
    // 获取当前点击的选项所在的容器
    let container = $(this).closest('.opt-group');
    container.find('.sp-option').removeClass("active");

    $(this).addClass("active");
    let that = this
    changePrice(that)

    // 获取当前容器所在的产品部分（主页面或弹窗）
    let productPart = $(this).closest('.product-part');
    
    // let style = productPart.find(".sp-style .sp-option.active").index();
 
    
    //获取当前激活选项的索引
    let color = productPart.find(".sp-color .sp-option.active").index();
    let size = productPart.find(".sp-size .sp-option.active").index();
    let type = productPart.find("#sp-type .sp-option.active").index();
    // console.log('ssssssssssssssssssssss', type);
    productPart.find('.sp-number').toggleClass('split-number-two', type == 2);

    // let _index = style + color * 2 + size * 8;
    let _index =  color + size * 4 + type * 8;
  
    // 更新当前产品部分的图片
    productPart.find(".sp-img-wrap img").attr('src', imgArr[_index]);
    
    // 更新数量显示
    let numberElement = productPart.find('.sp-img-wrap .sp-number');
    $(".product-part .sp-img-wrap .sp-number").css('right', '476px');
        $(".product-part .sp-img-wrap").css('padding-right', '0px');
        $(".product-part .sp-img-wrap .sp-free").css('left', '164px');
    if (size == 1) {
        numberElement.html('x4');
        numberElement.show();
    } else if (size == 0) {
        numberElement.html('x2');
        numberElement.show();
    } else {
        numberElement.html('x2');
        numberElement.show();
    }
    if (type) {
      numberElement.hide();
    }
});
// ... existing code ...

//数量控制函数
  $(".sp-reduce").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) - 1;
    let that = this
    if (num > 0) {
      input.value = num;
      changePrice(that)
    }
  });

  
  $(".sp-add").click(function () {
    let input = $(this).siblings("input")[0];
    let num = Number(input.value) + 1;
    input.value = num;
    let that = this
    changePrice(that)
  });

  $('.sp-btn-style').click(function(){
    let that = this
    let num = $(this).closest('.product-part').find('#calcNumber').val()
    window.location.href = '/cart/' + getCur(that).id + ':' + num
  })

  //将产品添加到购物车
  $(".cart-btn").click(function () {
    $(this).children("img").addClass("on");
    $(".sp-header-top .sp-cart .num").show();
    setTimeout(function () {
      $(".cart-btn").children("img").removeClass("on");
    }, 500);
    $(".sp-header-top .sp-cart").addClass("on");
    setTimeout(function () {
      $(".sp-header-top .sp-cart").removeClass("on");
    }, 500);
  });

  $(".product-part .cart-btn").click(function () {
    $(".sp-cart .num").addClass("sp-gray")
    let that = this
    var data = {
      id: getCur(that).id,
      quantity: $(this).closest('.product-part').find('#calcNumber').val(),
    };
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $("#cardNum").html(result.item_count);
        });
      },
      dataType: "json",
    });
    
    var img = $(this).closest('.product-part').find(".sp-img-wrap img");
    var flyer = img[0].cloneNode(true);
    flyer.classList.add("sp_clone");

    $(this).closest('.product-part').append(flyer);
    $(".sp_clone").css({
      width: img[0].width,
      height: img[0].height,
      position: "fixed",
      top: img[0].offsetTop,
      left: img.offset().left,
      "z-index": "99",
    });

    let finish = $(".sp-cart");
    $(".sp_clone").animate(
      {
        top: finish[0].offsetTop + 20 + $('.time-part').height(),
        left: finish[0].offsetLeft + finish.width() / 3,
        width: 50, // 结束时的大小，根据需要调整
        height: 50, // 结束时的大小，根据需要调整
        opacity: 0.4,
      },
      500,
      "linear",
      function () {
        $(this).animate(
          {
            width: 0,
            height: 0,
            opacity: 0,
          },
          0,
          function () {
            $(this).detach();
          }
        );
      }
    );
  });

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    $('.selectl span').click(function () {
      $(this).addClass("on").siblings().removeClass("on");
    })

    $(".selectl span").click(function () {
      $(this).addClass("on").siblings().removeClass("on");
    });

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top: offsetTop * $("div#root").css("zoom") - 240 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }



//   const tabs = $(".sp-tab");

//   let currentIndex = 0; // 当前展示的tab索引

//   function nextTabFunc() {
//     const currentTab = tabs[currentIndex];
//     // 当前tab开始动画
//     currentTab.classList.add("sp-tab-ani");

//     let nextIndex = (currentIndex + 1) % tabs.length;
//     const nextTab = tabs[nextIndex];

//     setTimeout(() => {
//       currentTab.classList.remove("sp-tab-ani");
//     }, 2500);

//     currentIndex = (currentIndex + 1) % tabs.length;
//     setTimeout(nextTabFunc, 1500);
//   }

//   nextTabFunc();



  // 标题文本渐出
  const graduallyList = document.getElementsByClassName("gradually");
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll("span");
    const paragraph = gradually.querySelector(".sp-sub-title");

    //监听元素进入视口，触发入场动画
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`;
              span.style.animationDelay = `${index * 0.1}s`;

              const i = span.querySelector("i");
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`;
                i.style.animationDelay = `${index * 0.1}s`;
              }
            });

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3;
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade 0.5s ease forwards`;
              paragraph.style.animationDelay = `${totalDelay}s`;
            }

            observer.unobserve(gradually);
          }
        });
      },
      {
        threshold: 0.3,
      }
    );
    observer.observe(gradually);
  }



  // 展示尺码弹窗
  // $('.sp-btn-pop').click(function () {
  //   $('.sp-mask').css('display', 'flex')
  //   // $(".sp-pop").show();
  // })
  // 关闭弹窗按钮

  $('.sp-close-btn').click(function (e) {
    $('.sp-mask').hide()
    // $(".sp-pop").hide();
  })



}

mainRender();

